import { defineStore } from "pinia";
import { ref } from "vue";

const localStorageKey = "odendo-cart-lines-count";

type UpdateCartEvent = () => void;

export const useCart = defineStore("cart", () => {
    const cartCount = ref(0);
    const updateCartEvents = ref<UpdateCartEvent[]>([]);

    function updateCartCount(value: number) {
        cartCount.value = value;
        triggerCartUpdate();
        if (window.localStorage != null) {
            window.localStorage.setItem(localStorageKey, value.toString());
        }
    }

    function onCartUpdate(handler: UpdateCartEvent) {
        updateCartEvents.value.push(handler);
        return {
            remove() {
                const index = updateCartEvents.value.indexOf(handler);
                if (index < 0) return;
                updateCartEvents.value.splice(index, 1);
            },
        };
    }

    function triggerCartUpdate() {
        for (const handler of updateCartEvents.value) {
            handler();
        }
    }

    function createObservable() {
        return cartCount;
    }

    window.addEventListener("storage", (e) => {
        if (e.key !== localStorageKey) return;
        if (e.newValue == null) return;
        cartCount.value = parseInt(e.newValue);
        triggerCartUpdate();
    });

    return {
        updateCartCount,
        cartCount,
        createObservable,
        onCartUpdate,
        triggerCartUpdate,
    };
});
